module.exports = __webpack_public_path__ + "static/media/i.1a5907ac.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/i.mp3
// module id = 98
// module chunks = 0